import { ErrorOption } from "react-hook-form";

import { Text } from "@/atoms";

type FieldErrorProps = {
  readonly error?: ErrorOption;
  readonly id: string;
};

export default function FieldError({
  error,
  id,
}: FieldErrorProps): React.ReactElement | null {
  return (
    <div className="flex items-center gap-1 text-red" id={id} role="alert">
      <Text component="span" text={error?.message} variant="error" />
    </div>
  );
}
